/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CalendlyLocations } from '../../models/calendly-locations';

export interface ListCalendlyLocations$Params {
}

export function listCalendlyLocations(http: HttpClient, rootUrl: string, params?: ListCalendlyLocations$Params, context?: HttpContext): Observable<StrictHttpResponse<CalendlyLocations>> {
  const rb = new RequestBuilder(rootUrl, listCalendlyLocations.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CalendlyLocations>;
    })
  );
}

listCalendlyLocations.PATH = '/v1/api/ui/calendly-demo/locations';
